export default __webpack_public_path__ + "static/media/dash_img.772e288d.png";